module.exports = __webpack_public_path__ + "img/logo.bc11a015.png";